import { useMemo } from 'react';
import { getAxiosClient } from '../http.client';
// Determine the API URL based on environment
export function useFluidFormConfigClient() {
    return useMemo(() => {
        return new FluidFormConfigClient();
    }, []);
}
export class FluidFormConfigClient {
    apiClient;
    constructor() { }
    async client() {
        if (this.apiClient) {
            return this.apiClient;
        }
        this.apiClient = getAxiosClient("admin/fluid-form-config");
        return this.apiClient;
    }
    async getFormConfig(formKey, submissionId) {
        const client = await this.client();
        try {
            const response = await client.get(`/${formKey}`, { params: { submissionId } });
            return response.data;
        }
        catch (error) {
            console.error('Error getting form config:', error);
            throw error;
        }
    }
    //List Form configs
    async listFormConfigs(includeDeleted = false) {
        try {
            const client = await this.client();
            const response = await client.get('/', { params: { includeDeleted } });
            return response.data;
        }
        catch (error) {
            console.error('Error listing form configs:', error);
            throw error;
        }
    }
    //Create Form config (no upsert)
    async createFormConfig(form) {
        try {
            const client = await this.client();
            await client.post(`/create`, form);
        }
        catch (error) {
            console.error('Error creating form config:', error);
            throw error;
        }
    }
    //Save Form config
    async saveFormConfig(form) {
        try {
            const client = await this.client();
            await client.post(`/`, form);
        }
        catch (error) {
            console.error('Error saving form config:', error);
            throw error;
        }
    }
    //Delete Form config
    async deleteFormConfig(formKey) {
        try {
            const client = await this.client();
            await client.delete(`/${formKey}`);
        }
        catch (error) {
            console.error('Error deleting form config:', error);
            throw error;
        }
    }
    //Generate signed signature for public form access
    async generateFormSignature(formKey) {
        try {
            const client = await this.client();
            const response = await client.post(`/${formKey}/signature`);
            return response.data;
        }
        catch (error) {
            console.error('Error generating form signature:', error);
            throw error;
        }
    }
    async publishForm(formKey) {
        try {
            const client = await this.client();
            const response = await client.post(`/${formKey}/publish`);
            return response.data;
        }
        catch (error) {
            console.error('Error publishing form:', error);
            throw error;
        }
    }
    async listVersions(formKey) {
        try {
            const client = await this.client();
            const response = await client.get(`/${formKey}/versions`);
            return response.data;
        }
        catch (error) {
            console.error('Error listing versions:', error);
            throw error;
        }
    }
    async activateVersion(formKey, versionId) {
        try {
            const client = await this.client();
            const response = await client.post(`/${formKey}/versions/${versionId}/activate`);
            return response.data;
        }
        catch (error) {
            console.error('Error activating version:', error);
            throw error;
        }
    }
    async listTemplates() {
        try {
            const client = await this.client();
            const response = await client.get(`/templates`);
            return response.data;
        }
        catch (error) {
            console.error('Error listing templates:', error);
            throw error;
        }
    }
    async getTemplate(orgId, formKey) {
        try {
            const client = await this.client();
            const response = await client.get(`/templates/${encodeURIComponent(orgId)}/${encodeURIComponent(formKey)}`);
            return response.data;
        }
        catch (error) {
            console.error('Error getting template:', error);
            throw error;
        }
    }
    async setTemplateFlag(formKey, isTemplate) {
        try {
            const client = await this.client();
            const response = await client.patch(`/${encodeURIComponent(formKey)}/template`, { isTemplate: !!isTemplate });
            return response.data;
        }
        catch (error) {
            console.error('Error setting template flag:', error);
            throw error;
        }
    }
}
